import { ModuleType } from "../../../Enums/ModuleType";

export const toolbarOptions = [
  [{ header: "1" }, { header: "2" }, { font: [] }],
  [{ size: [] }],
  ["bold", "italic", "underline", "strike", "blockquote"],
  [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
  ["link", "image", "video"],
  ["clean"],
];

export const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

export const ModuleTypeChoices = [
  { id: ModuleType.Pbh, name: "PBH" },
  { id: ModuleType.Rbh, name: "RBH" },
];

export const MailManagementExcelHeader = [
  {
    header: "CUSTOMER",
    key: "CUSTOMER",
    width: 25,
  },
  {
    header: "TO",
    key: "TO",
    width: 25,
  },
  {
    header: "CC",
    key: "CC",
    width: 25,
  },
  {
    header: "Subject",
    key: "Subject",
    width: 100,
  },
  {
    header: "Schema",
    key: "Schema",
    width: 50,
  },
];

export const MailManagementExcelName = "Mail Management List";
